/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AddOrUpdateTenderItems$Params {
  tenderId: string;
      body: {
[key: string]: number;
}
}

export function addOrUpdateTenderItems(http: HttpClient, rootUrl: string, params: AddOrUpdateTenderItems$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addOrUpdateTenderItems.PATH, 'put');
  if (params) {
    rb.path('tenderId', params.tenderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addOrUpdateTenderItems.PATH = '/tenders/{tenderId}/items';
